






















































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { TestimonialFilter, TestimonialOrderBy } from 'client-website-ts-library/filters';
import { WebsiteLevel } from 'client-website-ts-library/types';
import FaqQuestion from '@/components/FaqQuestion.vue';
import ContentContainer from '@/components/Layout/ContentContainer.vue';
import LinkButton from '@/components/UI/LinkButton.vue';
import TestimonialCycler from '@/components/Testimonials/TestimonialCycler.vue';
import FacebookWidget from '@/components/FacebookWidget.vue';
import ElfsightWhatsapp from '@/components/ElfsightWhatsapp.vue';
import ContactPopout from '@/components/ContactPopout.vue';
import ElfsightInstagram from '@/components/ElfsightInstagram.vue';
import Form from '../components/Forms/Form.vue';

@Component({
  components: {
    ContentContainer,
    LinkButton,
    FaqQuestion,
    TestimonialCycler,
    FacebookWidget,
    ElfsightWhatsapp,
    ContactPopout,
    Form,
    ElfsightInstagram,
  },
})
export default class PropertiesForRent extends Mixins(View) {
  testimonialFilter: TestimonialFilter | null = null;

  mounted() {
    this.testimonialFilter = new TestimonialFilter({
      SearchLevel: WebsiteLevel.Office,
      SearchGuid: '29d9080e-165e-4372-afc4-374f5b90fdde',
      OrderByStatements: [TestimonialOrderBy.CreateDateDesc],
    });
  }
}
